import React, { useEffect, useState } from 'react';
import { Outlet, useMatch, Navigate, useNavigate } from 'react-router-dom';
import { orderBy } from '@progress/kendo-data-query';
import useTranslate from '../../../../common/hooks/useTranslate';
import { useDispatch } from 'react-redux';
import { getActiveInvestors, IInvestor } from '../../../../common/services/http/investorsService';
import { SET_INVESTOR } from '../../../../redux/types';

import Main from '../../../layout/main/main';
import ComponentLoader from '../../../ui/loaders/componentLoader/componentLoader';

import './board.scss';
import OutletLoader from '../../../ui/loaders/outletLoader/outletLoader';

const BoardsContainer: React.FC = () => {
  const { t } = useTranslate();
  let match = useMatch('/boards');

  const [investorLoading, setInvestorLoading] = useState(true);
  const [investors, setInvestors] = useState([]);
  const [noInvestors, setNoInvestors] = useState(false);

  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    getActiveInvestors()
      .then((res: IInvestor[]) => {
        let dataArr = [];
        if (res.length === 0) {
          setNoInvestors(true);
        } else {
          res.forEach((item) => {
            dataArr.push({ name: item.name, id: item.objectId });
          });
          if (isMounted) {
            setInvestors(orderBy(dataArr, [{ field: 'name', dir: 'asc' }]));
            setInvestorLoading(false);
            dispatch({ type: SET_INVESTOR, investor: dataArr[0] });
          }
        }
      })
      .catch((err) => {
        setInvestorLoading(false);
        console.log('Investors error: ', err);
      });

    return () => {
      isMounted = false;
      setInvestors([]);
      setInvestorLoading(true);
      setNoInvestors(false);
    };
  }, []);

  const onChange = (e) => {
    dispatch({ type: SET_INVESTOR, investor: e.value });
    navigate(`/boards/${e.value.id}`, { replace: true });
  };

  return (
    <Main className="boards-wrapper" title={t('BOARDS.PAGE_TITLE')} investorDropdown={!noInvestors} investors={investors} onInvestorChange={onChange}>
      {noInvestors ? (
        <div className="no-boards-message-wrapper">
          <p>{t('BOARDS.NO_BOARDS')}</p>
        </div>
      ) : (
        <>{match && !investorLoading ? <Navigate to={`./${investors[0].id}`} /> : <Outlet />}</>
      )}
    </Main>
  );
};

export default BoardsContainer;
